import { useState } from "react";
import { Outlet } from "react-router-dom";
import { MainContextProvider } from "../../context/MainContext";
import styles from "./MainLayout.module.css";
import Header from "./Header";
import Sidebar from "./Sidebar";

const MainLayout = () => {
  const [sideBarOpen, setSideBarOpen] = useState(false);

  const handleSideBar = () => {
    setSideBarOpen(!sideBarOpen);
  };

  return (
    <>
      <MainContextProvider>
        <div className="h-100 d-flex flex-column">
          <Header sideBarOpen={sideBarOpen} onShowSideBar={handleSideBar} />
          {sideBarOpen && <Sidebar onItemClick={handleSideBar} />}
          <main
            className={
              sideBarOpen
                ? `${styles.sideBarBackground} flex-grow-1 d-flex flex-row overflow-auto`
                : `flex-grow-1 d-flex flex-row overflow-auto`
            }
          >
            <Outlet />
          </main>
        </div>
      </MainContextProvider>
    </>
  );
};

export default MainLayout;
